/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthChallengeAdminPost$Params {
  Email?: string;
  RefCode?: string;
  SessionCode?: string;
  ExpiredDate?: string;
  Otp?: string;
  ResultMsg?: string;
  IsError?: boolean;
  action?: string;
}

export function authChallengeAdminPost(http: HttpClient, rootUrl: string, params?: AuthChallengeAdminPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, authChallengeAdminPost.PATH, 'post');
  if (params) {
    rb.query('Email', params.Email, {});
    rb.query('RefCode', params.RefCode, {});
    rb.query('SessionCode', params.SessionCode, {});
    rb.query('ExpiredDate', params.ExpiredDate, {});
    rb.query('Otp', params.Otp, {});
    rb.query('ResultMsg', params.ResultMsg, {});
    rb.query('IsError', params.IsError, {});
    rb.query('action', params.action, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

authChallengeAdminPost.PATH = '/auth/challenge-admin';
